// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2D4rr","unreadBadge":"styles_unreadBadge__3pUIZ","modalContent":"styles_modalContent__3DuNK","modal":"styles_modal__k9rY-"};